// The list is extracted based on ISO 639 list
export enum PhishingLanguagesEnum {
  AA = 'aa_ET', // Afar
  AB = 'ab_GE', // Abkhazian
  AE = 'ae_IR', // Avestan
  AF = 'af_ZA', // Afrikaans
  AK = 'ak_GH', // Akan
  AM = 'am_ET', // Amharic
  AN = 'an_ES', // Aragonese
  AR = 'ar_SA', // Arabic
  AS = 'as_IN', // Assamese
  AV = 'av_RU', // Avaric
  AY = 'ay_BO', // Aymara
  AZ = 'az_AZ', // Azerbaijani
  BA = 'ba_RU', // Bashkir
  BE = 'be_BY', // Belarusian
  BG = 'bg_BG', // Bulgarian
  BI = 'bi_VU', // Bislama
  BM = 'bm_ML', // Bambara
  BN = 'bn_BD', // Bengali
  BO = 'bo_CN', // Tibetan
  BR = 'br_FR', // Breton
  BS = 'bs_BA', // Bosnian
  CA = 'ca_ES', // Catalan
  CE = 'ce_RU', // Chechen
  CH = 'ch_GU', // Chamorro
  CO = 'co_FR', // Corsican
  CR = 'cr_CA', // Cree
  CS = 'cs_CZ', // Czech
  CV = 'cv_RU', // Chuvash
  CY = 'cy_GB', // Welsh
  DA = 'da_DK', // Danish
  DE = 'de_DE', // German
  DV = 'dv_MV', // Divehi
  DZ = 'dz_BT', // Dzongkha
  EE = 'ee_GH', // Ewe
  EL = 'el_GR', // Greek
  EN = 'en_GB', // English
  EO = 'eo_XX', // Esperanto
  ES = 'es_ES', // Spanish
  ET = 'et_EE', // Estonian
  EU = 'eu_ES', // Basque
  FA = 'fa_IR', // Persian
  FF = 'ff_SN', // Fulah
  FI = 'fi_FI', // Finnish
  FJ = 'fj_FJ', // Fijian
  FO = 'fo_FO', // Faroese
  FR = 'fr_FR', // French
  FY = 'fy_NL', // Western Frisian
  GA = 'ga_IE', // Irish
  GD = 'gd_GB', // Gaelic
  GL = 'gl_ES', // Galician
  GN = 'gn_PY', // Guarani
  GU = 'gu_IN', // Gujarati
  GV = 'gv_IM', // Manx
  HA = 'ha_NG', // Hausa
  HE = 'he_IL', // Hebrew
  HI = 'hi_IN', // Hindi
  HO = 'ho_PG', // Hiri Motu
  HR = 'hr_HR', // Croatian
  HT = 'ht_HT', // Haitian
  HU = 'hu_HU', // Hungarian
  HY = 'hy_AM', // Armenian
  HZ = 'hz_NA', // Herero
  ID = 'id_ID', // Indonesian
  IE = 'ie_XX', // Interlingue
  IG = 'ig_NG', // Igbo
  II = 'ii_CN', // Sichuan Yi
  IK = 'ik_US', // Inupiaq
  IO = 'io_XX', // Ido
  IS = 'is_IS', // Icelandic
  IT = 'it_IT', // Italian
  IU = 'iu_CA', // Inuktitut
  JA = 'ja_JP', // Japanese
  JV = 'jv_ID', // Javanese
  KA = 'ka_GE', // Georgian
  KG = 'kg_CD', // Kongo
  KI = 'ki_KE', // Kikuyu
  KJ = 'kj_NA', // Kuanyama
  KK = 'kk_KZ', // Kazakh
  KL = 'kl_GL', // Kalaallisut
  KM = 'km_KH', // Central Khmer
  KN = 'kn_IN', // Kannada
  KO = 'ko_KR', // Korean
  KR = 'kr_NG', // Kanuri
  KS = 'ks_IN', // Kashmiri
  KU = 'ku_TR', // Kurdish
  KV = 'kv_RU', // Komi
  KW = 'kw_GB', // Cornish
  KY = 'ky_KG', // Kirghiz
  LA = 'la_VA', // Latin
  LB = 'lb_LU', // Luxembourgish
  LG = 'lg_UG', // Ganda
  LI = 'li_NL', // Limburgan
  LN = 'ln_CD', // Lingala
  LO = 'lo_LA', // Lao
  LT = 'lt_LT', // Lithuanian
  LU = 'lu_CD', // Luba-Katanga
  LV = 'lv_LV', // Latvian
  MG = 'mg_MG', // Malagasy
  MH = 'mh_MH', // Marshallese
  MI = 'mi_NZ', // Maori
  MK = 'mk_MK', // Macedonian
  ML = 'ml_IN', // Malayalam
  MN = 'mn_MN', // Mongolian
  MR = 'mr_IN', // Marathi
  MS = 'ms_MY', // Malay
  MT = 'mt_MT', // Maltese
  MY = 'my_MM', // Burmese
  NA = 'na_NR', // Nauru
  NB = 'nb_NO', // Bokmål, Norwegian
  ND = 'nd_ZW', // Ndebele, North
  NE = 'ne_NP', // Nepali
  NG = 'ng_NA', // Ndonga
  NL = 'nl_NL', // Dutch
  NN = 'nn_NO', // Norwegian Nynorsk
  NO = 'no_NO', // Norwegian
  NR = 'nr_ZA', // Ndebele, South
  NV = 'nv_US', // Navajo
  NY = 'ny_MW', // Chichewa
  OC = 'oc_FR', // Occitan
  OJ = 'oj_CA', // Ojibwa
  OM = 'om_ET', // Oromo
  OR = 'or_IN', // Oriya
  OS = 'os_GE', // Ossetian
  PA = 'pa_IN', // Panjabi
  PI = 'pi_IN', // Pali
  PL = 'pl_PL', // Polish
  PS = 'ps_AF', // Pushto
  PT = 'pt_PT', // Portuguese
  QU = 'qu_PE', // Quechua
  RM = 'rm_CH', // Romansh
  RN = 'rn_BI', // Rundi
  RO = 'ro_RO', // Romanian
  RU = 'ru_RU', // Russian
  RW = 'rw_RW', // Kinyarwanda
  SA = 'sa_IN', // Sanskrit
  SC = 'sc_IT', // Sardinian
  SD = 'sd_PK', // Sindhi
  SE = 'se_NO', // Northern Sami
  SG = 'sg_CF', // Sango
  SI = 'si_LK', // Sinhala
  SK = 'sk_SK', // Slovak
  SL = 'sl_SI', // Slovenian
  SM = 'sm_WS', // Samoan
  SN = 'sn_ZW', // Shona
  SO = 'so_SO', // Somali
  SQ = 'sq_AL', // Albanian
  SR = 'sr_RS', // Serbian
  SS = 'ss_SZ', // Swati
  ST = 'st_LS', // Sotho, Southern
  SU = 'su_ID', // Sundanese
  SV = 'sv_SE', // Swedish
  SW = 'sw_KE', // Swahili
  TA = 'ta_IN', // Tamil
  TE = 'te_IN', // Telugu
  TG = 'tg_TJ', // Tajik
  TH = 'th_TH', // Thai
  TI = 'ti_ER', // Tigrinya
  TK = 'tk_TM', // Turkmen
  TL = 'tl_PH', // Tagalog
  TN = 'tn_BW', // Tswana
  TO = 'to_TO', // Tonga
  TR = 'tr_TR', // Turkish
  TS = 'ts_ZA', // Tsonga
  TT = 'tt_RU', // Tatar
  TW = 'tw_GH', // Twi
  TY = 'ty_PF', // Tahitian
  UG = 'ug_CN', // Uighur
  UK = 'uk_UA', // Ukrainian
  UR = 'ur_PK', // Urdu
  UZ = 'uz_UZ', // Uzbek
  VE = 've_ZA', // Venda
  VI = 'vi_VN', // Vietnamese
  VO = 'vo_XX', // Volapük
  WA = 'wa_BE', // Walloon
  WO = 'wo_SN', // Wolof
  XH = 'xh_ZA', // Xhosa
  YI = 'yi_IL', // Yiddish
  YO = 'yo_NG', // Yoruba
  ZA = 'za_CN', // Zhuang
  ZH = 'zh_CN', // Chinese
  ZU = 'zu_ZA', // Zulu
}

export const phishingLanguageDisplayLabel: { [key: string]: string } = {
  [PhishingLanguagesEnum.SQ]: 'Shqip [Albanian]',
  [PhishingLanguagesEnum.AB]: 'Аҧсуа [Abkhazian]',
  [PhishingLanguagesEnum.AF]: 'Afrikaans [Afrikaans]',
  [PhishingLanguagesEnum.AA]: 'Qafar af [Afar]',
  [PhishingLanguagesEnum.AK]: 'Akan [Akan]',
  [PhishingLanguagesEnum.AM]: 'አማርኛ [Amharic]',
  [PhishingLanguagesEnum.AR]: 'اَلْعَرَبِيَّة [Arabic]',
  [PhishingLanguagesEnum.AN]: 'Aragonés [Aragonese]',
  [PhishingLanguagesEnum.HY]: 'Հայերեն [Armenian]',
  [PhishingLanguagesEnum.AS]: 'অসমীয়া [Assamese]',
  [PhishingLanguagesEnum.AV]: 'Авар мацӏ [Avaric]',
  [PhishingLanguagesEnum.AE]: 'avesta [Avestan]',
  [PhishingLanguagesEnum.AY]: 'Aymara [Aymara]',
  [PhishingLanguagesEnum.AZ]: 'azərbaycan dili [Azerbaijani]',
  [PhishingLanguagesEnum.BM]: 'Bamanankan [Bambara]',
  [PhishingLanguagesEnum.EU]: 'Euskara/Euskera [Basque]',
  [PhishingLanguagesEnum.BA]: 'Башҡорт теле [Bashkir]',
  [PhishingLanguagesEnum.BE]: 'Беларуская мова [Belarusian]',
  [PhishingLanguagesEnum.BN]: 'বাংলা [Bengali]',
  [PhishingLanguagesEnum.BI]: 'Bislama [Bislama]',
  [PhishingLanguagesEnum.NB]: 'Norsk bokmål [Bokmål, Norwegian]',
  [PhishingLanguagesEnum.BS]: 'Босански [Bosnian]',
  [PhishingLanguagesEnum.BR]: 'brezhoneg [Breton]',
  [PhishingLanguagesEnum.BG]: 'Български [Bulgarian]',
  [PhishingLanguagesEnum.MY]: 'မြန်မာစာ [Burmese]',
  [PhishingLanguagesEnum.CA]: 'Català [Catalan]',
  [PhishingLanguagesEnum.KM]: 'ខេមរភាសា; [Central Khmer]',
  [PhishingLanguagesEnum.CH]: 'Finu` Chamoru [Chamorro]',
  [PhishingLanguagesEnum.CE]: 'Нохчийн мотт [Chechen]',
  [PhishingLanguagesEnum.NY]: 'Chichewa [Chichewa, Chewa, Nyanja]',
  [PhishingLanguagesEnum.ZH]: '中文 [Chinese]',
  [PhishingLanguagesEnum.CV]: 'Чӑвашла [Chuvash]',
  [PhishingLanguagesEnum.KW]: 'Kernowek [Cornish]',
  [PhishingLanguagesEnum.CO]: 'Corsu [Corsican]',
  [PhishingLanguagesEnum.CR]: 'ᓀᐦᐃᔭᐁᐧᐃᐧᐣ [Cree]',
  [PhishingLanguagesEnum.HR]: 'Hrvatski [Croatian]',
  [PhishingLanguagesEnum.CS]: 'Čeština [Czech]',
  [PhishingLanguagesEnum.DA]: 'Dansk [Danish]',
  [PhishingLanguagesEnum.DV]: 'ދިވެހި [Divehi, Dhivehi, Maldivian]',
  [PhishingLanguagesEnum.NL]: 'Nederlands [Dutch]',
  [PhishingLanguagesEnum.DZ]: 'རྫོང་ཁ་ [Dzongkha]',
  [PhishingLanguagesEnum.EN]: 'English [English]',
  [PhishingLanguagesEnum.EO]: 'Esperanto [Esperanto]',
  [PhishingLanguagesEnum.ET]: 'Eesti keel [Estonian]',
  [PhishingLanguagesEnum.EE]: 'Èʋegbe [Ewe]',
  [PhishingLanguagesEnum.FO]: 'føroyskt [Faroese]',
  [PhishingLanguagesEnum.FJ]: 'Na Vosa Vakaviti [Fijian]',
  [PhishingLanguagesEnum.FI]: 'Suomi [Finnish]',
  [PhishingLanguagesEnum.FR]: 'Français [French]',
  [PhishingLanguagesEnum.FF]: 'Fulfulde [Fulah]',
  [PhishingLanguagesEnum.GD]: 'Gàidhlig [Gaelic]',
  [PhishingLanguagesEnum.GL]: 'Galego [Galician]',
  [PhishingLanguagesEnum.LG]: 'Luganda [Ganda]',
  [PhishingLanguagesEnum.KA]: 'ქართული [Georgian]',
  [PhishingLanguagesEnum.DE]: 'Deutsch [German]',
  [PhishingLanguagesEnum.EL]: 'Νέα Ελληνικά [Greek]',
  [PhishingLanguagesEnum.GN]: 'Avañe`ẽ [Guarani]',
  [PhishingLanguagesEnum.GU]: 'ગુજરાતી [Gujarati]',
  [PhishingLanguagesEnum.HT]: 'Kreyòl ayisyen [Haitian]',
  [PhishingLanguagesEnum.HA]: 'هَرْشٜن هَوْس [Hausa]',
  [PhishingLanguagesEnum.HE]: 'עִבְרִית‎ [Hebrew]',
  [PhishingLanguagesEnum.HZ]: 'Otjiherero [Herero]',
  [PhishingLanguagesEnum.HI]: 'हिन्दी [Hindi]',
  [PhishingLanguagesEnum.HO]: 'Hiri Motu [Hiri Motu]',
  [PhishingLanguagesEnum.HU]: 'Magyar nyelv [Hungarian]',
  [PhishingLanguagesEnum.IG]: 'ásụ̀sụ́ Ìgbò [Igbo]',
  [PhishingLanguagesEnum.IO]: 'Ido [Ido]',
  [PhishingLanguagesEnum.IS]: 'Íslenska [Icelandic]',
  [PhishingLanguagesEnum.ID]: 'bahasa Indonesia [Indonesian]',
  [PhishingLanguagesEnum.IE]: 'Interlingue [Interlingue, Occidental]',
  [PhishingLanguagesEnum.IK]: 'Iñupiaq [Inupiaq]',
  [PhishingLanguagesEnum.IU]: 'ᐃᓄᒃᑎᑐᑦ [Inuktitut]',
  [PhishingLanguagesEnum.GA]: 'Gaeilge [Irish]',
  [PhishingLanguagesEnum.IT]: 'Italiano [Italian]',
  [PhishingLanguagesEnum.JA]: '日本語 [Japanese]',
  [PhishingLanguagesEnum.JV]: 'ꦧꦱꦗꦮ [Javanese]',
  [PhishingLanguagesEnum.KN]: 'ಕನ್ನಡ [Kannada]',
  [PhishingLanguagesEnum.KR]: 'كَنُرِيِه [Kanuri]',
  [PhishingLanguagesEnum.KS]: 'कॉशुर [Kashmiri]',
  [PhishingLanguagesEnum.KK]: 'Қазақша [Kazakh]',
  [PhishingLanguagesEnum.KL]: 'Kalaallisut [Kalaallisut]',
  [PhishingLanguagesEnum.KI]: 'Gĩgĩkũyũ [Kikuyu, Gikuyu]',
  [PhishingLanguagesEnum.RW]: 'Ikinyarwanda [Kinyarwanda]',
  [PhishingLanguagesEnum.KY]: 'Кыргыз [Kyrgyz]',
  [PhishingLanguagesEnum.KV]: 'Коми кыв [Komi]',
  [PhishingLanguagesEnum.KG]: 'Kikongo [Kongo]',
  [PhishingLanguagesEnum.KO]: '한국어 [Korean]',
  [PhishingLanguagesEnum.KJ]: 'Oshikwanyama [Kuanyama, Kwanyama]',
  [PhishingLanguagesEnum.KU]: 'کوردی [Kurdish]',
  [PhishingLanguagesEnum.LO]: 'ພາສາລາວ [Lao]',
  [PhishingLanguagesEnum.LA]: 'Latinum [Latin]',
  [PhishingLanguagesEnum.LV]: 'Latviešu [Latvian]',
  [PhishingLanguagesEnum.LI]: 'Lèmburgs [Limburgan]',
  [PhishingLanguagesEnum.LN]: 'Lingála [Lingala]',
  [PhishingLanguagesEnum.LT]: 'Lietuvių [Lithuanian]',
  [PhishingLanguagesEnum.LU]: 'Kiluba [Luba-Katanga]',
  [PhishingLanguagesEnum.LB]: 'Lëtzebuergesch [Luxembourgish]',
  [PhishingLanguagesEnum.MK]: 'Македонски [Macedonian]',
  [PhishingLanguagesEnum.MG]: 'مَلَغَسِ [Malagasy]',
  [PhishingLanguagesEnum.MS]: 'بهاس ملايو [Malay]',
  [PhishingLanguagesEnum.ML]: 'മലയാളം [Malayalam]',
  [PhishingLanguagesEnum.MT]: 'Malti [Maltese]',
  [PhishingLanguagesEnum.GV]: 'Gaelg [Manx]',
  [PhishingLanguagesEnum.MI]: 'reo Māori [Maori]',
  [PhishingLanguagesEnum.MR]: 'मराठी [Marathi]',
  [PhishingLanguagesEnum.MH]: 'Kajin M̧ajeļ [Marshallese]',
  [PhishingLanguagesEnum.MN]: 'Монгол хэл [Mongolian]',
  [PhishingLanguagesEnum.ND]: 'isiNdebele [Ndebele, North]',
  [PhishingLanguagesEnum.NR]: 'isiNdebele [Ndebele, South]',
  [PhishingLanguagesEnum.NG]: 'Owambo [Ndonga]',
  [PhishingLanguagesEnum.NE]: 'नेपाली [Nepali]',
  [PhishingLanguagesEnum.NO]: 'Norsk [Norwegian]',
  [PhishingLanguagesEnum.NN]: 'Norsk nynorsk [Norwegian Nynorsk]',
  [PhishingLanguagesEnum.SE]: 'Davvisámegiella [Northern Sami]',
  [PhishingLanguagesEnum.NA]: 'Dorerin Naoero [Nauru]',
  [PhishingLanguagesEnum.NV]: 'Diné bizaad [Navajo]',
  [PhishingLanguagesEnum.OC]: 'occitan [Occitan]',
  [PhishingLanguagesEnum.OJ]: 'ᐊᓂᔑᓈᐯᒧᐎᓐ [Ojibwa]',
  [PhishingLanguagesEnum.OR]: 'ଓଡ଼ିଆ [Oriya]',
  [PhishingLanguagesEnum.OM]: 'Afaan Oromoo [Oromo]',
  [PhishingLanguagesEnum.OS]: 'ирон æвзаг [Ossetian]',
  [PhishingLanguagesEnum.PI]: 'पालि [Pali]',
  [PhishingLanguagesEnum.PA]: 'ਪੰਜਾਬੀ [Panjabi]',
  [PhishingLanguagesEnum.FA]: 'فارسی [Persian]',
  [PhishingLanguagesEnum.PL]: 'Polski [Polish]',
  [PhishingLanguagesEnum.PT]: 'Português [Portuguese]',
  [PhishingLanguagesEnum.PS]: 'پښتو [Pushto]',
  [PhishingLanguagesEnum.QU]: 'Runa Simi [Quechua]',
  [PhishingLanguagesEnum.RM]: 'rumantsch grischun [Romansh]',
  [PhishingLanguagesEnum.RN]: 'Ikirundi [Rundi]',
  [PhishingLanguagesEnum.RO]: 'Română [Romanian]',
  [PhishingLanguagesEnum.RU]: 'Русский [Russian]',
  [PhishingLanguagesEnum.SG]: 'yângâ tî sängö [Sango]',
  [PhishingLanguagesEnum.SA]: 'संस्कृतम् [Sanskrit]',
  [PhishingLanguagesEnum.SC]: 'sardu [Sardinian]',
  [PhishingLanguagesEnum.SM]: 'gagana fa`a Samoa [Samoan]',
  [PhishingLanguagesEnum.SR]: 'Српски [Serbian]',
  [PhishingLanguagesEnum.SN]: 'chiShona [Shona]',
  [PhishingLanguagesEnum.II]: 'ꆈꌠꉙ [Sichuan Yi]',
  [PhishingLanguagesEnum.SD]: 'सिन्धी [Sindhi]',
  [PhishingLanguagesEnum.SI]: 'සිංහල [Sinhala]',
  [PhishingLanguagesEnum.SK]: 'Slovenčina [Slovak]',
  [PhishingLanguagesEnum.SL]: 'Slovenščina [Slovenian]',
  [PhishingLanguagesEnum.SO]: 'Soomaaliga [Somali]',
  [PhishingLanguagesEnum.ST]: 'Sesotho [Sotho, Southern]',
  [PhishingLanguagesEnum.ES]: 'Español [Spanish]',
  [PhishingLanguagesEnum.SU]: 'Basa Sunda [Sundanese]',
  [PhishingLanguagesEnum.SW]: 'Kiswahili [Swahili]',
  [PhishingLanguagesEnum.SS]: 'SiSwati [Swati]',
  [PhishingLanguagesEnum.SV]: 'Svenska [Swedish]',
  [PhishingLanguagesEnum.TL]: 'Wikang Tagalog [Tagalog]',
  [PhishingLanguagesEnum.TY]: 'Reo Tahiti [Tahitian]',
  [PhishingLanguagesEnum.TG]: 'Тоҷикӣ [Tajik]',
  [PhishingLanguagesEnum.TA]: 'தமிழ் [Tamil]',
  [PhishingLanguagesEnum.TT]: 'Tatar tele [Tatar]',
  [PhishingLanguagesEnum.TE]: 'తెలుగు [Telugu]',
  [PhishingLanguagesEnum.TH]: 'ไทย [Thai]',
  [PhishingLanguagesEnum.BO]: 'བོད་ཡིག [Tibetan]',
  [PhishingLanguagesEnum.TI]: 'ትግርኛ [Tigrinya]',
  [PhishingLanguagesEnum.TO]: 'faka Tonga [Tonga]',
  [PhishingLanguagesEnum.TS]: 'Xitsonga [Tsonga]',
  [PhishingLanguagesEnum.TN]: 'Setswana [Tswana]',
  [PhishingLanguagesEnum.TR]: 'Türkçe [Turkish]',
  [PhishingLanguagesEnum.TK]: 'Türkmen [Turkmen]',
  [PhishingLanguagesEnum.TW]: 'Twi [Twi]',
  [PhishingLanguagesEnum.UG]: 'ئۇيغۇرچە [Uighur]',
  [PhishingLanguagesEnum.UK]: 'Украї́нська мо́ва [Ukrainian]',
  [PhishingLanguagesEnum.UR]: 'اردو [Urdu]',
  [PhishingLanguagesEnum.UZ]: 'Oʻzbek [Uzbek]',
  [PhishingLanguagesEnum.VE]: 'Tshivenḓa [Venda]',
  [PhishingLanguagesEnum.VI]: 'Tiếng Việt [Vietnamese]',
  [PhishingLanguagesEnum.VO]: 'Volapük [Volapük]',
  [PhishingLanguagesEnum.WA]: 'walon [Walloon]',
  [PhishingLanguagesEnum.CY]: 'Cymraeg [Welsh]',
  [PhishingLanguagesEnum.FY]: 'Frysk [Western Frisian]',
  [PhishingLanguagesEnum.WO]: 'Wollof [Wolof]',
  [PhishingLanguagesEnum.XH]: 'isiXhosa [Xhosa]',
  [PhishingLanguagesEnum.YI]: 'ייִדיש [Yiddish]',
  [PhishingLanguagesEnum.YO]: 'Yorùbá [Yoruba]',
  [PhishingLanguagesEnum.ZA]: 'Saɯ cueŋƅ [Zhuang]',
  [PhishingLanguagesEnum.ZU]: 'isiZulu [Zulu]',
};

export const phishingLanguagesDropdown = Object.values(PhishingLanguagesEnum)
  .map((value) => ({
    label: phishingLanguageDisplayLabel[value],
    value,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const campaignGenerationLanguagesDropdown = [
  PhishingLanguagesEnum.DA,
  PhishingLanguagesEnum.DE,
  PhishingLanguagesEnum.ET,
  PhishingLanguagesEnum.EN,
  PhishingLanguagesEnum.ES,
  PhishingLanguagesEnum.FR,
  PhishingLanguagesEnum.KL,
  PhishingLanguagesEnum.LT,
  PhishingLanguagesEnum.NL,
  PhishingLanguagesEnum.NB,
  PhishingLanguagesEnum.PL,
  PhishingLanguagesEnum.PT,
  PhishingLanguagesEnum.FI,
  PhishingLanguagesEnum.SV,
  PhishingLanguagesEnum.VI,
].map((value) => ({
  label: phishingLanguageDisplayLabel[value],
  value,
}));
